import { Link } from 'react-router-dom'
import type { CityId } from '@/lib/city'

type Language = 'el' | 'en'

interface PopularLinesProps {
  cityId: CityId
  lang: Language
  translations: {
    popularLines: string
    allLines: string
  }
}

const POPULAR_LINES: Record<CityId, Array<{
  id: string
  description: Record<Language, string>
}>> = {
  athens: [
    { id: 'X95', description: { en: 'Syntagma - Airport', el: 'Σύνταγμα - Αεροδρόμιο' } },
    { id: 'X96', description: { en: 'Piraeus - Airport', el: 'Πειραιάς - Αεροδρόμιο' } },
    { id: '040', description: { en: 'Syntagma - Piraeus (24h)', el: 'Σύνταγμα - Πειραιάς (24ω)' } },
    { id: 'A1', description: { en: 'Piraeus - Voula', el: 'Πειραιάς - Βούλα' } },
    { id: 'A2', description: { en: 'Academy - Voula', el: 'Ακαδημία - Βούλα' } },
    { id: 'A3', description: { en: 'Academy - Glyfada', el: 'Ακαδημία - Γλυφάδα' } },
    { id: 'B5', description: { en: 'Larissa Stn - Ag. Paraskevi', el: 'Στ. Λαρίσης - Αγ. Παρασκευή' } },
    { id: '550', description: { en: 'Kifissia - Palaio Faliro', el: 'Κηφισιά - Παλαιό Φάληρο' } },
    { id: 'X97', description: { en: 'Elliniko - Airport', el: 'Ελληνικό - Αεροδρόμιο' } },
  ],
  thessaloniki: [
    { id: '01X', description: { en: 'KTEL - Airport', el: 'Κ.Τ.Ε.Λ. - Αεροδρόμιο' } },
    { id: '02K', description: { en: 'IKEA - KTEL Macedonia', el: 'Α.Σ. ΙΚΕΑ - Κ.Τ.Ε.Λ. Μακεδονία' } },
    { id: '03K', description: { en: 'IKEA - Railway Station', el: 'Α.Σ. ΙΚΕΑ - Ν.Σ. Σταθμός' } },
    { id: '05', description: { en: 'Nea Krini - Venizelou', el: 'Ν. Κρήνη - Βενιζέλου' } },
    { id: '10', description: { en: 'Nea Elvetia Metro - Railway Station', el: 'Μετρό Ν. Ελβετίας - Ν.Σ. Σταθμός' } },
    { id: '12', description: { en: 'KTEL - Kato Toumba', el: 'Κ.Τ.Ε.Λ. - Κάτω Τούμπα' } },
    { id: '14', description: { en: 'Ano Toumba - Railway Station', el: 'Άνω Τούμπα - Ν.Σ. Σταθμός' } },
    { id: '31', description: { en: 'Voulgari - KTEL', el: 'Βούλγαρη - Κ.Τ.Ε.Λ.' } },
    { id: '58', description: { en: 'Hortiatis Junction - Panorama - Venizelou', el: 'Διασταύρωση Χορτιάτη - Πανόραμα - Βενιζέλου' } },
  ],
}

export function PopularLines({ cityId, lang, translations: t }: PopularLinesProps) {
  return (
    <div className="popular-lines">
      <h3>{t.popularLines}</h3>
      <div className="popular-lines-grid">
        {POPULAR_LINES[cityId].map(line => (
          <Link
            key={line.id}
            className="popular-line-card"
            to={`/${line.id.toLowerCase()}`}
          >
            <div className="popular-line-id">{line.id}</div>
            <div className="popular-line-desc">{line.description[lang]}</div>
          </Link>
        ))}
      </div>
      <Link to="/lines" className="all-lines-button">
        {t.allLines} →
      </Link>
    </div>
  )
}
